import { render, staticRenderFns } from "./FairSeries.vue?vue&type=template&id=002614ac&scoped=true"
import script from "./FairSeries.vue?vue&type=script&lang=js"
export * from "./FairSeries.vue?vue&type=script&lang=js"
import style0 from "./FairSeries.vue?vue&type=style&index=0&id=002614ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002614ac",
  null
  
)

export default component.exports